import React from "react";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  wrapperDisabled: {
    display: "block",
    backgroundColor: "rgb(216 216 216)",
    borderRadius: "30px",
    color: "white",
    padding: "8px",
    textAlign: "center",
    margin: "15px",
    fontFamily: "thonburiregular",
    fontStyle: "normal",
    fontSize: "18px"
  },
  wrapper: {
    display: "block",
    backgroundColor: "#ff8300",
    borderRadius: "30px",
    color: "white",
    padding: "8px",
    textAlign: "center",
    cursor: "pointer",
    margin: "15px",
    fontFamily: "thonburiregular",
    fontStyle: "normal",
    fontSize: "18px"
  },
  wrapperDisabledNoMargin: {
    display: "block",
    backgroundColor: "rgb(216 216 216)",
    borderRadius: "30px",
    color: "white",
    padding: "8px",
    textAlign: "center",
    fontFamily: "thonburiregular",
    fontStyle: "normal",
    fontSize: "18px"
  },
  wrapperNoMargin: {
    display: "block",
    backgroundColor: "#ff8300",
    borderRadius: "30px",
    color: "white",
    padding: "8px",
    textAlign: "center",
    cursor: "pointer",
    fontFamily: "thonburiregular",
    fontStyle: "normal",
    fontSize: "18px"
  },
  clearWrapper: {
    display: "block",
    border: "1px solid #ff8300",
    borderRadius: "30px",
    color: "#ff8300",
    padding: "8px",
    textAlign: "center",
    cursor: "pointer",
    margin: "15px",
    fontFamily: "thonburiregular",
    fontStyle: "normal",
    fontSize: "18px"
  },
  clearWrapperNoMargin: {
    display: "block",
    border: "1px solid #ff8300",
    borderRadius: "30px",
    color: "#ff8300",
    padding: "8px",
    textAlign: "center",
    cursor: "pointer",
    fontFamily: "thonburiregular",
    fontStyle: "normal",
    fontSize: "18px"
  }
};

const SubmitButton = props => {
  const { classes, children, disabled, ...otherProps } = props;
  let thisClassName = "";
  if (otherProps.margin) {
    if (!otherProps.clear) {
      thisClassName = disabled ? classes.wrapperDisabled : classes.wrapper;
    } else {
      thisClassName = classes.clearWrapper;
    }
  } else {
    if (!otherProps.clear) {
      thisClassName = disabled
        ? classes.wrapperDisabledNoMargin
        : classes.wrapperNoMargin;
    } else {
      thisClassName = classes.clearWrapperNoMargin;
    }
  }
  return (
    <div className={thisClassName} {...otherProps}>
      {children}
    </div>
  );
};

export default withStyles(styles)(SubmitButton);
